import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import "./scss/account-management.scss";
import { Link } from "react-router-dom";
import { GLOBAL_ACCOUNT, ADD_ACCOUNT } from "../../constants/route-paths";
import {
  getAccountsList,
  updateAccount,
  deleteAccount,
  loginToAccount,
  updateAccountStatus,
} from "../../actions/global-account.action";
import {
  exportUserAccountData,
  checkUserAccountExportStatus,
  downloadUserAccountExport,
} from "../../actions/account-export.action";
import DeleteDialog from "../../components/delete-dialog";
import ExportModal from "../../components/export-modal/export-modal";
import { withRouter } from "../../util/with-router";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import CustomTable from "../../components/table/table";
import LoginIcon from '@mui/icons-material/Login';
import idx from "idx";
import { FileDownload } from "@mui/icons-material";
import { exportAccountData, checkAccountExportStatus, downloadAccountExport, importAccountData, checkAccountImportStatus } from "src/actions/global-setting.action";
import { persistantSnackbar, successSnackBar } from "src/actions/common.action";

class AccountsList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ActiveAccount: [],
      InactiveAccount: [],
      deleteDialogState: false,
      data: [],
      type: "active",
      accountId: null,
      importFile: null,
      importAccountId: null,
      exportModalOpen: false,
      selectedAccountId: null,
    };

    // Create a hidden file input for importing
    this.fileInputRef = React.createRef();
  }

  componentDidMount() {
    this.getAccountsList();
  }

  getAccountsList = () => {
    this.props.getAccountsList().then((accounts) => {
      const data = accounts.map((account) => {
        return {
          name: account.name,
          status: account.status,
          email: account.email,
          phone_number: account.phone_number,
          id: account.id,
        };
      });
      const ActiveAccount = data.filter((account) => {
        if (account.status === "ACTIVE") {
          return account;
        } else {
          return undefined;
        }
      });
      const InactiveAccount = data.filter((account) => {
        if (account.status === "INACTIVE") {
          return account;
        } else {
          return undefined;
        }
      });

      this.setState({
        accounts: data,
        data: ActiveAccount,
        ActiveAccount,
        InactiveAccount,
      });

      const { type } = this.state;
      this.filter(type);
    });
  };

  getColumns = () => {
    return [
      {
        title: "Name",
        field: "name",
        dataCy: "account-name",
        render: (rowData) => (
          <Link to={`/${GLOBAL_ACCOUNT}/edit/${rowData.id}`}>
            {rowData.name}
          </Link>
        ),
      },
      {
        title: "Status",
        field: "status",
        dataCy: "account-status",
        render: (rowData) =>
          rowData.status === "ACTIVE" ?
            (<span style={{ color: "#2BAA0E" }}>Active</span>)
            : (<span style={{ color: "#D0021B" }}>Inactive</span>),
      },
      { title: "Email", field: "email", dataCy: "account-email" },
      { title: "Phone Number", field: "phone_number" },
      {
        title: "Active",
        field: "status",
        lookup: { true: "ACTIVE", false: "INACTIVE" },
        dataCy: "account-active",
        render: (rowData) => (
          <div className="form-check form-switch">
            <input
              className={`form-check-input switch-checkbox ${rowData.status === "ACTIVE" ? '' : 'inactive'}`}
              type="checkbox"
              role="switch"
              id="flexSwitchCheckDefault"
              disabled={!this.props.writePermission}
              value={rowData.status === "ACTIVE" ? true : false}
              checked={rowData.status === "ACTIVE" ? true : false}
              onChange={(e) =>
                this.handleStatusChange(e.target.checked, rowData.id)
              }
            />
            <label className="form-check-label" htmlFor="flexSwitchCheckDefault"></label>
          </div>
        ),
      },
    ];
  };

  addAccount = () => {
    this.props.history(`/${GLOBAL_ACCOUNT}/${ADD_ACCOUNT}`);
  };

  updateAccount = (id) => {
    this.props.history(`/${GLOBAL_ACCOUNT}/edit/${id}`);
  };

  deleteHandler = (id) => {
    this.props.deleteAccount(this.state.deleteId).then((res) => {
      this.deleteDialogHandler();
      this.getAccountsList();
    });
  };

  deleteDescription = () => {
    const { deleteId, ActiveAccount, InactiveAccount } = this.state;
    const accountList = [...ActiveAccount, ...InactiveAccount]
    const account = accountList.find(_ => _.id === deleteId);
    const accountName = idx(account, _ => _.name) || '';
    return accountName
  }

  handleStatusChange = (status, id = "") => {
    status = status ? "ACTIVE" : "INACTIVE";
    this.props.updateAccountStatus({ status }, id).then((res) => {
      this.getAccountsList();
    });
  };

  handleLoginToAccount = (id = "") => {
    const { accounts } = this.state;
    let account = accounts.filter((account) => account.id === id)[0];
    this.props.loginToAccount(id, account.name);
  };

  handleExportAccount = async (id) => {
    try {
      // First check if there's an existing export
      const status = await this.props.checkAccountExportStatus({ account_id: id });

      if (status && status.inProgress) {
        // If export is in progress, show progress
        this.props.successSnackBar(`Export in progress: ${status.progress}% complete`);
        return;
      }

      if (status && status.isComplete && status.file_url) {
        // If new export can be started
        if (status.canStartNew) {
          await this.props.exportAccountData({ account_id: id });
          this.props.successSnackBar('Export process started. You will be notified when complete.');
          return;
        }

        // If export is complete and we have a file URL, download it
        const downloadResponse = await this.props.downloadAccountExport({ account_id: id });
        if (downloadResponse && downloadResponse.url) {
          this.props.successSnackBar('Export downloaded successfully');
        } else {
          throw new Error('Download failed - no URL received');
        }
        return;
      }

      // If no export exists or last one failed, start new export
      await this.props.exportAccountData({ account_id: id });
      this.props.successSnackBar('Export process started. You will be notified when complete.');

    } catch (error) {
      console.error('Export failed: ' + error, 'error');
    }
  }

  handleUserAccountExport = async (id) => {
    try {
      const status = await this.props.checkUserAccountExportStatus({ account_id: id });

      if (status && status.inProgress) {
        this.props.successSnackBar(`Export in progress: ${status.progress}% complete`);
        return;
      }

      if (status && status.isComplete && status.file_url) {
        if (status.canStartNew) {
          await this.props.exportUserAccountData({ account_id: id });
          this.props.successSnackBar('Export process started. You will be notified when complete.');
          return;
        }
        
        const downloadResponse = await this.props.downloadUserAccountExport({ account_id: id });
        if (downloadResponse && downloadResponse.url) {
          this.props.successSnackBar('Export downloaded successfully');
        } else {
          throw new Error('Download failed - no URL received');
        }
        return;
      }

      await this.props.exportUserAccountData({ account_id: id });
      this.props.successSnackBar('Export process started. You will be notified when complete.');

    } catch (error) {
      console.error('Export failed: ' + error, 'error');
    }
  }

  handleOpenExportModal = (id) => {
    this.setState({
      exportModalOpen: true,
      selectedAccountId: id
    });
  }

  handleCloseExportModal = () => {
    this.setState({
      exportModalOpen: false,
      selectedAccountId: null
    });
  }

  deleteDialogHandler = (id = "") => {
    this.setState((prevState) => ({
      deleteDialogState: !prevState.deleteDialogState,
      deleteId: id,
    }));
  };

  filter = (status) => {
    if (status === "active") {
      this.setState((prevState) => ({
        data: prevState.ActiveAccount,
        type: status,
      }));
    } else if (status === "inactive") {
      this.setState((prevState) => ({
        data: prevState.InactiveAccount,
        type: status,
      }));
    }
  };

  render() {
    const {
      ActiveAccount,
      InactiveAccount,
      deleteDialogState,
      deleteId,
      exportModalOpen,
      selectedAccountId
    } = this.state;

    return (
      <>
        <DeleteDialog
          open={deleteDialogState}
          id={deleteId}
          deleteHandler={this.deleteHandler}
          dialogClose={this.deleteDialogHandler}
          moduleName="Account"
          description={this.deleteDescription()}
          dataCy="delete-dialog"
        />

        <ExportModal 
          open={exportModalOpen}
          onClose={this.handleCloseExportModal}
          onExportUserData={this.handleUserAccountExport}
          onExportAccountData={this.handleExportAccount}
          accountId={selectedAccountId}
          dataCy="export-modal"
        />

        <div className="purchase-order-block" data-cy="accounts-list">
          <div className="row">
            <div className="w-auto">
              <h2 className="content-heading text-uppercase">Accounts</h2>
            </div>

            {this.props.writePermission && (<div className="w-auto ms-auto mt-auto">
              <button onClick={this.addAccount} className="secondarybtn secondarybtn-outline btn-ch ms-auto btn btn-primary">Add Account</button>
            </div>)}
          </div>

          <div className="row">
            <div className="col-12">
              <Tabs
                defaultActiveKey="active"
                id="uncontrolled-tab-example"
                className="mb-3"
                tabClassName="active-accounts-tab"
              >
                <Tab eventKey="active" title={`Active Accounts (${ActiveAccount.length})`}>
                  <CustomTable
                    columns={this.getColumns()}
                    data={ActiveAccount}
                    dataCy="active-accounts-table"
                    isMore={(item) => this.props.user.selected_account.id != item.id ? this.props.writePermission : false}
                    isMoreIcon={<LoginIcon />}
                    isMoreHandler={(item) => this.handleLoginToAccount(item.id)}
                    isEdit={this.props.writePermission}
                    editHandler={(item) => this.updateAccount(item.id)}
                    isDelete={(item) => this.props.user.selected_account.id != item.id ? this.props.writePermission : false}
                    deleteHandler={(item) => this.deleteDialogHandler(item.id)}
                    additionalActions={[
                      this.props.user.selected_account.id !== null && {
                        icon: <FileDownload />,
                        label: 'Export',
                        handler: (item) => this.handleOpenExportModal(item.id),
                        show: true
                      }
                    ]}
                    fileName="Active Accounts List"
                  />
                </Tab>
                <Tab eventKey="inactive" title={`In-Active Accounts (${InactiveAccount.length})`} tabClassName="inactive-accounts-tab">
                  <CustomTable
                    columns={this.getColumns()}
                    data={InactiveAccount}
                    dataCy="inactive-accounts-table"
                    isMore={(item) => this.props.user.selected_account.id != item.id ? this.props.writePermission : false}
                    isMoreIcon={<LoginIcon />}
                    isMoreHandler={(item) => this.handleLoginToAccount(item.id)}
                    isEdit={this.props.writePermission}
                    editHandler={(item) => this.updateAccount(item.id)}
                    isDelete={(item) => this.props.user.selected_account.id != item.id ? this.props.writePermission : false}
                    deleteHandler={(item) => this.deleteDialogHandler(item.id)}
                    additionalActions={[
                      this.props.user.selected_account.id !== null && {
                        icon: <FileDownload />,
                        label: 'Export',
                        handler: (item) => this.handleOpenExportModal(item.id),
                        show: true
                      }
                    ]}
                    fileName="In Active Accounts List"
                  />
                </Tab>
              </Tabs>
            </div>
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user.userData,
});

const mapDispatchToProps = (dispatch) => ({
  getAccountsList: bindActionCreators(getAccountsList, dispatch),
  loginToAccount: bindActionCreators(loginToAccount, dispatch),
  updateAccount: bindActionCreators(updateAccount, dispatch),
  deleteAccount: bindActionCreators(deleteAccount, dispatch),
  exportAccountData: bindActionCreators(exportAccountData, dispatch),
  checkAccountExportStatus: bindActionCreators(checkAccountExportStatus, dispatch),
  downloadAccountExport: bindActionCreators(downloadAccountExport, dispatch),
  importAccountData: bindActionCreators(importAccountData, dispatch),
  checkAccountImportStatus: bindActionCreators(checkAccountImportStatus, dispatch),
  persistantSnackbar: bindActionCreators(persistantSnackbar, dispatch),
  updateAccountStatus: bindActionCreators(updateAccountStatus, dispatch),
  successSnackBar: bindActionCreators(successSnackBar, dispatch),
  exportUserAccountData: bindActionCreators(exportUserAccountData, dispatch),
  checkUserAccountExportStatus: bindActionCreators(checkUserAccountExportStatus, dispatch),
  downloadUserAccountExport: bindActionCreators(downloadUserAccountExport, dispatch),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AccountsList)
);
